module.exports = __webpack_public_path__ + "media/images/new/icons/li_steps_header-0e42f0ec2e8ab96ce6bee73f74bd558c.png";